import { render, staticRenderFns } from "./salesRecord.vue?vue&type=template&id=8c7c1cfa&scoped=true&"
import script from "./salesRecord.vue?vue&type=script&lang=js&"
export * from "./salesRecord.vue?vue&type=script&lang=js&"
import style0 from "./salesRecord.vue?vue&type=style&index=0&id=8c7c1cfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7c1cfa",
  null
  
)

export default component.exports